export default {
  questions: [],
  tests: [],
  packages: [],
  banners: [],
  categories: [],
  advertisments: [],
  signs: [],
  sign_categories: [],
  theories: [],
}
